import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import Card from "../../UI/Card/Card";
import Button from "../../UI/Button/Button";
import ErrorPanel, { ErrorSize } from "../../UI/ErrorPanel/ErrorPanel";

import { faEdit } from "@fortawesome/free-solid-svg-icons";

import * as InvoicesActions from "../../../middleware/Store/Actions/InvoicesActions";

import LogService from "../../../middleware/CommonSdk/LogService";
const LOG_TAG = "INVOICES_OPTIONS";

const InvoicesOptions = (props) => {

    const intl = useIntl();
    const title = intl.messages.invoicesOptions;
    const subtitle = intl.messages.invoicesOptionsMessage;

    const [progress, setProgress] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [email, setEmail] = useState("");
    const [receiveByEmails, setReceiveByEmails] = useState("");
    const [additionalEmails, setAdditionalEmails] = useState("");

    useEffect(() => {
        setProgress(props.progress);
    }, [props.progress]);

    useEffect(() => {
        if (props.error && props.error.errorMessage) {
            setErrorMessage(props.error.errorMessage);
        }
    }, [props.error]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect InvoicesOption => billToContact");
        if (props.account && props.account.data && props.account.data.billToContact) {
            setEmail(props.account.data.billToContact.workEmail)
        }
    }, [props.account]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect InvoicesOption => billingAndPayment");
        if (props.account && props.account.data && props.account.data.billingAndPayment) {
            setReceiveByEmails(props.account.data.billingAndPayment.invoiceDeliveryPrefsEmail);
            if (Array.isArray(props.account.data.billingAndPayment.additionalEmailAddresses)) {
                setAdditionalEmails(props.account.data.billingAndPayment.additionalEmailAddresses.join(";"));
            }
        }
    }, [props.account]);

    const handleChangeReceive = (e) => {
        LogService.trace(LOG_TAG, "handleChangeReceive", e.target.value);
        let val = e.target.value === "yes" ? true : false
        setReceiveByEmails(val);
    }

    const handleChangeAdditionalEmails = (e) => {
        setAdditionalEmails(e.target.value);
    }

    const handleUpdateOption = (e) => {
        LogService.info(LOG_TAG, "handleUpdateOption", "Submit invoices options");
        e.preventDefault();

        //Remove space
        let value = additionalEmails.trim().replace(/\s/g, "");
        let emails = null;

        //Split and filter by removing empty element
        if (value) {
            emails = value.split(";").filter(Boolean);
        }

        let data = {
            invoiceDeliveryPrefsEmail: receiveByEmails,
            additionalEmailAddresses: emails
        };

        props.saveInvoiceOptions(props.user.id, data);
    }

    let zoneFooter = <div className="form-row align-items-center">
        <div className="col-md-5">
            <Button
                label={intl.messages.update}
                icon={faEdit}
                onClick={handleUpdateOption}
                spinner={progress}
                disabled={progress}
            className="btn-submit"
            />
        </div>

        {(errorMessage.length > 0) &&
            <div className="col-md-7">
                <ErrorPanel id="server-error" size={ErrorSize.Small}>{errorMessage}</ErrorPanel>
            </div>
        }
    </div>

    return (
        <Card title={title} subtitle={subtitle} action={zoneFooter}>
            <div className="form-group">
                <label className="input-label" htmlFor="selectEmails">{intl.messages.invoicesReceive}</label>
                <select id="selectEmails" className="form-control mb-1"
                    value={receiveByEmails ? "yes" : "no"}
                    onChange={handleChangeReceive}
                >
                    <option key="yes" value="yes">{intl.messages.invoicesReceiveChoiceYes}</option>
                    <option key="no" value="no">{intl.messages.invoicesReceiveChoiceNo}</option>
                </select>
            </div>

            <div className="panel bg-fog mb-3">{intl.messages.invoicesReceiveMessage}</div>

            <div className="form-group">
                <label htmlFor="inputEmail" className="input-label">{intl.messages.invoicesEmail}</label>
                <input
                    id="inputEmail"
                    value={email}
                    type="text"
                    className="form-control"
                    disabled={true}
                />
            </div>

            <div className="form-group">
                <label htmlFor="inputEmailsOther" className="input-label">{intl.messages.invoicesMoreEmail}</label>
                <input
                    id="inputEmailsOther"
                    value={additionalEmails}
                    type="text"
                    placeholder=""
                    className="form-control"
                    autoComplete="off"
                    onChange={handleChangeAdditionalEmails}
                />
            </div>

            <div className="panel bg-fog mb-3">{intl.messages.invoicesEmailMessage} </div>

            {/* <div className="form-row align-items-center">
            <div className="col-md-4">
                <Button
                    label={intl.messages.update}
                    icon={faEdit}
                    onClick={handleUpdateOption}
                    spinner={progress}
                    disabled={progress}
                />

            </div>

            {errorMessage && errorMessage.length > 0 &&
                <div className="col-md-8">
                    <ErrorPanel >{errorMessage}</ErrorPanel>
                </div>
            }
            </div> */}

        </Card>
    )
}

const mapStateToProps = state => {
    return {
        user: state.contacts.user,
        account: state.invoices.account,
        progress: state.invoices.updateOptionProgress,
        error: state.invoices.updateOptionError
    };
};

const mapDispatchToProps = dispatch => {
    return {
        saveInvoiceOptions: (userId, data) => dispatch(InvoicesActions.saveInvoiceOptions(userId, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesOptions);